export default __webpack_public_path__ + "143f3768c54f7350348b1fcc7bd8d124.jpg";